module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/workspace-footer/equal-housing-lender.png?03d2ec370d6a2a6f419c26f3cc4cdc35";